export default __webpack_public_path__ + "static/evolution-15799afb4827c59a174195b1b15fa217.jpg";